module.exports = __webpack_public_path__ + "static/media/Q4-5.331ef847.jpg";